module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAANuCAMAAADggZOpAAAAYFBMVEX//+3+/dz89q/68Y3//un+/eD58IP573/785r573z+/ub+/Nj9+9D68Ib++9T+/uP9+sn79J/79KP79qv68Yn79af897T9+cX8+Lj8+L/68pP68pD685b9+sz8+Lv9+cLodHLGAAAAUElEQVR4XrXBhQGAQBADMNzdnf23ZIVeyyeeS5G8oLfU2NyXlr9t4BX1Jnbg1fyF7sDHfAMu0kA4QmfxAO3FGfWiHoanYWg6yWtqIk4dzNUf4yUw/QA7r1wAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./assets/images/marjor-intro-content.png
// module id = 526
// module chunks = 0